import log from '../../lib/logger'
const state = {
  // TODO get initial contextState from server
  // export const loadData = ({commit}) => {
  //   Vue.http.get('audio.json')
  //       .then(response => response.json())
  //       .then(response => {
  //         if (response) {
  //           commit('SET_AUDIO', response)
  //         }
  //       })
  // }

  contextState: {
    consent: {
      component: 'Consent',
      consentStatus: false,
      consentTimestamp: '',
      completed: false
    },
    audiocheck: {
      component: 'AudioCheck',
      completed: false
    },
    questions: {
      component: 'Rules',
      answers: '',
      completed: false
    },
    task: {
      component: 'Task',
      completed: false
    },
    done: {
      component: 'Done',
      responses: '',
      completed: false
    },
    feedback: {
      component: 'Feedback',
      feedback: '',
      completed: false
    },
    resultsummary: {
      component: 'Resultsummary',
      feedback: '',
      completed: false
    },
    logout: {
      component: 'Logout',
      completed: false
    },
    currentContext: 'consent'
  }
}

const originalContextState = JSON.parse(JSON.stringify(state.contextState))

const mutations = {
  'SET_CONSENT' (state, payload) {
    state.contextState.consent.consentStatus = payload.status
    state.contextState.consent.consentTimestamp = payload.timestamp
    state.contextState.consent.consentUpload = payload.upload
    state.contextState.consent.completed = payload.completed
  },
  'SET_AUDIOCHECKCONTEXT' (state, status) {
    state.contextState.audiocheck.completed = status
  },
  'SET_QUESTIONCONTEXT' (state, answers) {
    state.contextState.questions.answers = answers
    state.contextState.questions.completed = true
  },
  'SET_DONECONTEXT' (state, responses) {
    state.contextState.done.responses = responses
    state.contextState.done.completed = true
  },
  'SET_FEEDBACKCONTEXT' (state, feedback) {
    state.contextState.feedback.feedback = feedback
    state.contextState.feedback.completed = true
  },
  'SET_CURRENTCONTEXT' (state, context) {
    state.contextState.currentContext = context
  },
  'RESET_CONTEXT' (state, context) {
    state.contextState[context] = originalContextState[context]
  },
  'RESET_ALLCONTEXT' (state) {
    state.contextState = originalContextState
  },
  'SET_INITIALCONTEXT' (state) {
    state.contextState = '' // STATE FROM SERVER
  }
}

const actions = {
  // context actions
  updateConsentContext: ({commit, state}, status, upload) => {
    let payload = {
      status: status,
      timestamp: new Date().getTime(),
      upload: upload,
      completed: status
    }
    commit('SET_CONSENT', payload)
  },
  updateAudioCheckContext: ({commit, state}, status) => {
    commit('SET_AUDIOCHECKCONTEXT', status)
  },
  updateQuestionContext: ({commit, state}, answers) => {
    commit('SET_QUESTIONCONTEXT', answers)
  },
  updateCurrentContext: ({commit, state}, context) => {
    if (state.contextState.consent.consentStatus && state.contextState.consent.completed) {
      commit('SET_CURRENTCONTEXT', context)
    } else {
      commit('SET_CURRENTCONTEXT', 'consent')
      return 'Cannot change before consent is given.'
    }
  },
  updateDoneContext: ({commit, state}, responses) => {
    commit('SET_DONECONTEXT', responses)
  },
  updateFeedbackContext: ({commit, state}, feedback) => {
    commit('SET_FEEDBACKCONTEXT', feedback)
  },
  resetContext: ({commit}, context) => {
    commit('RESET_CONTEXT', context)
  },
  resetAllContext: ({commit}) => {
    commit('RESET_ALLCONTEXT')
  },
  setInitialContextState: ({commit}) => {
    // export const loadData = ({commit}) => {
    //   Vue.http.get('contextstate')
    //       .then(response => response.json())
    //       .then(response => {
    //         if (response) {
    //           commit('SET_INITIALCONTEXT', response)
    //         }
    //       })
    // }
  },
  logoutAtEnd: ({commit, state}) => {
    window.dirty = false
  }
}
 // getters
const getters = {
  currentContext: state => {
    log.debug('Getting current context...')
    if (state.contextState.consent.completed && state.contextState.consent.consentStatus) {
      log.debug('... returning ' + state.contextState.currentContext)
      return state.contextState[state.contextState.currentContext].component
    } else {
      log.debug('... no consent.')
      return 'consent'
    }
  },
  consentState: state => {
    log.debug('Getting consent state...')
    return state.contextState.consent
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/context.js